<!--
  AI:
  Status: "confirmed"
  Type: Component
  SubType: ObjectBaseComponent
  Reason: Template for CrCustomerInsurableObjectObjectComponent - header with type icon, formatName
          and customer plus the shared navigation rail with Zuordnung / Objekt / Adresse.
-->
@if (initialized && dto) {

    <div class="cr-customer-insurable-object-object flex flex-column gap-3">

        <!-- Header: type icon + formatName of the linked object, plus the customer -->
        <div class="flex align-items-center gap-3">
            <mvs-icon
                    [icon]="getTypeIcon()"
                    [class]="'text-2xl'"
                    [ngStyle]="getTypeIconStyle()">
            </mvs-icon>

            <div class="flex flex-column">
                <span class="text-lg font-semibold">{{ getObjectLabel() }}</span>

                <div class="flex align-items-center gap-2 text-sm text-gray-600">
                    @if (getTypeName()) {
                        <span>{{ getTypeName() }}</span>
                        <span>·</span>
                    }
                    <span>{{ getCustomerLabel() }}</span>
                </div>
            </div>
        </div>

        @if (objectError) {
            <p-message severity="error" [text]="objectError"></p-message>
        }

        <!--
          Shared icon rail (GC18). The rail owns the sideNavItem query parameter; the items are not
          emitted upward, so a host that renders its own navigation sidebar cannot draw a second one.
        -->
        <object-component-navigation-side
                [name]="getObjectLabel()"
                [navigationItems]="navigationItems"
                [(activeNavigationItem)]="activeNavigationItem">
        </object-component-navigation-side>

        <!-- ───────────────────── Zuordnung ───────────────────── -->
        @if (isSectionActive('assignment')) {
            <!-- AI: CRUD Object Component for cr.CustomerInsurableObject (update) -->
            <mvs-crud-object
                    [objectType]="'cr.CustomerInsurableObject'"
                    [objectId]="objectIdentifier.objectId"
                    [importObjectContextDto]="formImportObjectContext"
                    (onChangedObject)="handleChangedAssignment($event)">
            </mvs-crud-object>
        }

        <!-- ─────────────────────── Objekt ─────────────────────── -->
        @if (isSectionActive('object')) {

            @if (objectBusy) {
                <p-skeleton height="12rem" borderRadius="0.5rem"></p-skeleton>
            } @else if (getInsurableObjectId()) {
                <!-- AI: CRUD Object Component for ci.InsurableObject (update, dynamic generic fields) -->
                <mvs-crud-object
                        [objectType]="'ci.InsurableObject'"
                        [objectId]="getInsurableObjectId()"
                        [importObjectContextDto]="formImportObjectContext"
                        (onChangedObject)="handleChangedInsurableObject($event)">
                </mvs-crud-object>
            }
        }

        <!-- ────────────────────── Adresse ────────────────────── -->
        @if (isSectionActive('address') && getAddressId()) {

            <div class="flex flex-column gap-2">
                <span class="text-sm text-gray-600">
                    Objektspezifische Adresse - sie gehört zu diesem Objekt und nicht zum Kunden.
                </span>

                <!-- AI: CRUD Object Component for ad.Address (update) -->
                <mvs-crud-object
                        [objectType]="getAddressObjectType()"
                        [objectId]="getAddressId()"
                        (onChangedObject)="handleChangedInsurableObject($event)">
                </mvs-crud-object>
            </div>
        }

    </div>
}
